export { ReactComponent as LinkRemove } from './svgs/link-remove.svg';
